import React, { Component } from 'react';

class HomeStaticBanner8sub extends Component {

    constructor(props) {
        super(props);
        this.state = {
            // menu:[],
        }
    }

    render() {
        const banners = this.props.banner;

        return (     
        <div className="container">
            <section className="ps-section--categories ps-home-static-banner8sub">
                <div className="ps-home-static-banner8sub__hero">
                    <div className="ps-home-static-banner8sub__eyebrow">Also available on</div>
                    <h2 className="ps-home-static-banner8sub__title">Discover Nature Way across trusted platforms</h2>
                    <p className="ps-home-static-banner8sub__subtitle">A curated set of channels where you can explore and shop with ease.</p>
                    <span className="ps-home-static-banner8sub__badge">Certified natural selection</span>
                </div>
                <div className="ps-section__content ps-home-static-banner8sub__content">
                    <div className="ps-categories__list">
                    {/* #b46735 */}

                        {
                            banners.map((bannerItem, index)=>{
                                return( 
                                    <div className="ps-categories__item" key={`${bannerItem.link_url}-${bannerItem.image_title}-${index}`}>
                                        <a className="ps-categories__link" href={`${bannerItem.link_url}`}><img src={bannerItem.image_path} alt={bannerItem.image_title || 'Category'} /></a>
                                            <a className="ps-categories__name" href={`${bannerItem.link_url}`}>{bannerItem.image_title}</a>
                                        </div>
                                    )
                                })
                            }
                    </div>
                    {/* <div className="text-center"> <a className="ps-categories__show" href="/">Show all</a></div> */}
                </div>
            </section>
        </div>
        );
    }
}

export default HomeStaticBanner8sub;
